import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import { getJsonFile } from '../../utils/request';

const LottieAnimation = ({ filePath }) => {
  const lottieOptions = useRef({
    loop: true,
    autoplay: true,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  });
  const [animationData, setAnimationData] = useState(null);
  useEffect(() => {
    const getAnimationData = async () => {
      const { data } = await getJsonFile(filePath);
      lottieOptions.current.animationData = data;
      setAnimationData(data);
    };

    if (!animationData) {
      getAnimationData();
    }
  }, [animationData]);

  if (!animationData) {
    return null;
  }

  return <Lottie options={lottieOptions.current} style={{ transform: 'translate3d(0,0,0)' }} />;
};

LottieAnimation.propTypes = {
  /**
   * Path of animation json file
   */
  filePath: PropTypes.string
};

LottieAnimation.defaultProps = {
  filePath: ''
};

export default LottieAnimation;
